// src/data/initialState.ts — Fase 5
import { GAME_CONFIG, TRAINER_CONFIG } from './gameConfig.js';
import type { PlayerState } from '../entities/player.js';
import { createInitialMissions } from './missions.js';

export function createInitialState(playerName = 'Explorador'): PlayerState {
  const now = new Date().toISOString();
  return {
    meta: { saveVersion: GAME_CONFIG.saveVersion, createdAt: now, updatedAt: now, slot: 1 },
    profile: { name: playerName, avatarId: 'aurora', title: 'Explorador Novato' },
    trainer: { level: 1, xp: 0, xpToNext: TRAINER_CONFIG.baseXpToLevel, aureos: 120 },
    world: {
      region: GAME_CONFIG.defaultRegion,
      zoneId: GAME_CONFIG.defaultZone,
      position: { x: 14, y: 12 },
      facing: 'south',
      discoveredRegions: [GAME_CONFIG.defaultRegion],
      discoveredZones: [GAME_CONFIG.defaultZone],
      flags: {}
    },
    team: { asterias: [], boxed: [] },
    registry: {},
    inventory: [
      { id: 'nucleo_vinculo', qty: 12 },
      { id: 'pocion_aurea', qty: 5 },
      { id: 'cristal_lumen', qty: 2 },
      { id: 'pan_aureliano', qty: 2 }
    ],
    currency: 120,
    collectedObjects: [],
    missions: createInitialMissions(),
    badges: [],
    story: { chapter: 0, flags: { prologoVisto: true, tutorialCompletado: false, llegoAVilla: true } },
    options: { masterVolume: 0.85, musicVolume: 0.7, sfxVolume: 0.8, language: 'es', reducedMotion: false, textSpeed: 'normal' },
    stats: { playtimeSeconds: 0, stepsWalked: 0, asteriasCaptured: 0, battlesWon: 0, encounters: 0, missionsCompleted: 0, objectsCollected: 0 },
    time: { tick: 0.25, phase: 'dia' }
  };
}

export const INITIAL_STATE = createInitialState();
